export const extractGroupReturnReason = (pendingReturnItems) => {
  if (pendingReturnItems.length === 0) return '—';
  const rr = pendingReturnItems[0]?.returnRequest;
  if (!rr) return '—';
  
  const extract = details => {
    if (!details) return undefined;
    if (typeof details === 'string') {
      try { return JSON.parse(details).reason; } catch { return undefined; }
    }
    return details.reason;
  };
  
  const raw = rr.reason || extract(rr.requestDetails) || '—';
  return raw.replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
};

export const calculateHeldDuration = (entity, pendingReturnItems) => {
  const fgDeliveryTimestamp = entity?.deliveredAt ||
    entity?.delivered_at ||
    entity?.fulfillmentGroup?.deliveredAt ||
    entity?.fulfillmentGroup?.delivered_at ||
    (pendingReturnItems[0]?.deliveredAt || pendingReturnItems[0]?.delivered_at);

  if (!fgDeliveryTimestamp) return null;
  
  const deliveredDate = new Date(fgDeliveryTimestamp);
  if (isNaN(deliveredDate.getTime())) return null;
  
  const diffMs = Date.now() - deliveredDate.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);
  
  if (diffHours < 24) {
    const hrs = Math.floor(diffHours);
    return `${hrs} hour${hrs !== 1 ? 's' : ''}`;
  } else {
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
  }
};

export const filterPendingReturnItems = (entity) => {
  if (!entity?.orderItems) return [];
  return entity.orderItems.filter(
    item => item.status === 'return_requested_by_customer'
  );
}; 